import { ActionType } from 'typesafe-actions';

import * as ReportsActions from 'store/actions/reports';
import { ReportsResponse, NewReportResponse } from 'store/types/reports';
import { call, put, takeEvery } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';
import Endpoints from 'endpoints';
import GipsyyGDSApi from 'apis/GipsyGDS';

function* getReports(action: ActionType<typeof ReportsActions.getReports.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: ReportsResponse[] } } = yield GipsyyGDSApi.get(Endpoints.getReports(), {
      params: {
        startDate: action.payload.startDate,
        finalDate: action.payload.finalDate,
      },
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(ReportsActions.getReports.success(response.data.data));
    yield call(resolvePromiseAction, action, response.data.data);
    yield response.data.data;
  } catch (error) {
    yield put(ReportsActions.getReports.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getNewReports(action: ActionType<typeof ReportsActions.getNewReports.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { reports: NewReportResponse[] } } = yield GipsyyGDSApi.get(Endpoints.getNewReports(), {
      params: {
        startDate: action.payload.startDate,
        finalDate: action.payload.finalDate,
        ClientPaymentMethod: action.payload.ClientPaymentMethod,
        CashFlowType: action.payload.CashFlowType,
        UserId: action.payload.UserId,
        AgencyId: action.payload.AgencyId,
      },
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(ReportsActions.getNewReports.success(response.data.reports));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(ReportsActions.getReports.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getPaymentMethodsReports(action: ActionType<typeof ReportsActions.getPaymentMethodsReports.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: any } } = yield GipsyyGDSApi.get(Endpoints.getPaymentMethods(), {
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(ReportsActions.getPaymentMethodsReports.success(response.data.data));
    yield call(resolvePromiseAction, action, response.data.data);
  } catch (error) {
    yield put(ReportsActions.getReports.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getCashFlowType(action: ActionType<typeof ReportsActions.getCashFlowType.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: any } } = yield GipsyyGDSApi.get(Endpoints.getCashFlowType(), {
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(ReportsActions.getCashFlowType.success(response.data.data));
    yield call(resolvePromiseAction, action, response.data.data);
  } catch (error) {
    yield put(ReportsActions.getReports.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getUsersFromAgency(action: ActionType<typeof ReportsActions.getUsersFromAgency.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: any } } = yield GipsyyGDSApi.get(Endpoints.getUsersFromAgency(), {
      headers: {
        Authorization: `bearer ${token}`,
      },
      params: {
        AgencyId: action?.payload,
      },
    });

    yield put(ReportsActions.getUsersFromAgency.success(response.data.data));
    yield call(resolvePromiseAction, action, response.data.data);
  } catch (error) {
    yield put(ReportsActions.getUsersFromAgency.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getAllAgencies(action: ActionType<typeof ReportsActions.getAllAgencies.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: { data: any } } = yield GipsyyGDSApi.get(Endpoints.getAllAgencies(), {
      headers: {
        Authorization: `bearer ${token}`,
      },
    });

    yield put(ReportsActions.getAllAgencies.success(response.data.data));
    yield call(resolvePromiseAction, action, response.data.data);
  } catch (error) {
    yield put(ReportsActions.getAllAgencies.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchReports = [
  takeEvery(ReportsActions.getPaymentMethodsReports.request, getPaymentMethodsReports),
  takeEvery(ReportsActions.getCashFlowType.request, getCashFlowType),
  takeEvery(ReportsActions.getUsersFromAgency.request, getUsersFromAgency),
  takeEvery(ReportsActions.getReports.request, getReports),
  takeEvery(ReportsActions.getNewReports.request, getNewReports),
  takeEvery(ReportsActions.getAllAgencies.request, getAllAgencies),
];
